export default __webpack_public_path__ + "static/media/token-metric.cb810fde.png";